import { GatsbyImage } from 'gatsby-plugin-image';
import Cookies from 'js-cookie';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Form from '../../Common/DynamicForm/Form';
import { ArrowLink } from '../../Common/Links';
import MarketoForm from '../../Common/MarketoForm/MarketoForm';
import RichTextConverter from '../../Common/RichText/RichTextConverter';
import * as styles from './GatedForm.module.css';

const COOKIE = '_fs_lcaccess';

const SuccessMessage = () => (
  <div className={styles.success}>
    <h2>Thank You</h2>
    <p>Please check your email for the file.</p>
  </div>
);

const GatedForm = ({
  splitName,
  title,
  successCopy,
  fileUrl,
  contentIsDownloadable,
  heroImage,
  marketoFormId,
  dynamicForm,
  onSuccess,
  trackingPixelUrl,
  uniqueTrackingPixel,
  downloadCtaLabel,
  //forceSuccess = false,
}) => {
  const cookieName = `${COOKIE}-${title?.replace(' ', '-')}`;
  const [showFormSuccess, setShowFormSuccess] = useState(Cookies.get(cookieName));
  let label = downloadCtaLabel || 'Download the paper';

  const onFormSuccess = () => {
    setShowFormSuccess(true);
    Cookies.set(cookieName, 'true', { expires: 1000 });
    onSuccess && onSuccess();
  };

  const isDownloadable = contentIsDownloadable?.[0] === 'Yes';
  const hasOverride = !!successCopy;
  let successMessage = <SuccessMessage />;
  if (isDownloadable && !hasOverride) {
    successMessage = (
      <div key="arrow-content-available" className={[styles.success, 'gated-download-content-available'].join(' ')}>
        {fileUrl && <ArrowLink url={fileUrl} label={label} isArrowDown isLarge isExternal isDownload />}
      </div>
    );
  } else if (isDownloadable && hasOverride) {
    successMessage = (
      <div
        key="rich-text-arrow-content-available"
        className={[styles.success, 'gated-download-content-available'].join(' ')}
      >
        <RichTextConverter copy={successCopy} />
        {fileUrl && (
          <div>
            <ArrowLink url={fileUrl} label={label} isArrowDown isLarge isExternal isDownload />
          </div>
        )}
      </div>
    );
  } else if (hasOverride) {
    successMessage = (
      <div key="rich-text-content-available" className={[styles.success, 'gated-content-available'].join(' ')}>
        <RichTextConverter copy={successCopy} />
      </div>
    );
  }

  const imageData = get(heroImage, 'gatsbyImageData');
  const img = get(heroImage, 'file.url');
  let image;
  if (imageData) {
    image = (
      <GatsbyImage
        image={get(heroImage, 'gatsbyImageData')}
        className={styles.heroImage}
        imgStyle={{ objectFit: 'contain' }}
        alt={title}
      />
    );
  } else if (img) {
    image = <img src={img} className={styles.heroImage} loading="lazy" alt={title} />;
  }

  let form = (
    <MarketoForm
      splitName={splitName}
      trackingPixelUrl={trackingPixelUrl}
      addHiddenFields
      formId={marketoFormId}
      onSuccess={() => onFormSuccess()}
      forceForm={true}
    />
  );
  if (dynamicForm && (dynamicForm.enabled || dynamicForm.useDynamicForms)) {
    form = (
      <Form
        onSuccess={() => onFormSuccess()}
        form={dynamicForm.marketoForm}
        programName={dynamicForm.marketoProgramName}
      />
    );
  }

  return (
    <div className={styles.container}>
      {image && <div className={styles.imgContainer}>{image}</div>}
      {!showFormSuccess && form}
      {showFormSuccess && (
        <div key="success-message">
          {successMessage}
          {trackingPixelUrl && <img src={trackingPixelUrl} height="1" width="1" style={{ display: 'none' }} alt="" />}
        </div>
      )}
      {showFormSuccess && uniqueTrackingPixel && (
        <img src={uniqueTrackingPixel} height="1" width="1" style={{ display: 'none' }} alt="" />
      )}
    </div>
  );
};

export const propTypes = {
  title: PropTypes.string,
  successCopy: PropTypes.object,
  fileUrl: PropTypes.string,
  contentIsDownloadable: PropTypes.array,
  heroImage: PropTypes.object,
  marketoFormId: PropTypes.string,
};

GatedForm.propTypes = {
  ...propTypes,
};

export default GatedForm;
